import { getForums, addForum } from '../forums';
import { exportActivities } from './index';

const exportForums = data => {
    return exportActivities({ ...data, getter: getForums, adder: addForum, dateField: 'initialDate' });
};

export default exportForums;
